export default __webpack_public_path__ + "static/orange_frog_center-7ded76ac17c33388261e475dc6885316.png";